module.exports = __webpack_public_path__ + "media/images/selected_rectangle-3126f17314509afb4b0213af89b6447b.svg";